import {useSelector} from 'react-redux';
import {selectCustomerGroupsKey} from 'coreStore/data/customer';

/**
 * useCustomerGroupsKey custom hook
 */
export default function useCustomerGroupsKey(): string|undefined {
	return useSelector((state) => selectCustomerGroupsKey(state));
};
